import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Controller } from 'react-hook-form';

const EzControlledDropDown = (props) => {
  const {
    control,
    name,
    shouldFilter = true,
    filterBy,
    options,
    optionLabel = 'label',
    optionValue = 'value',
    rules,
    onChange,
    disabled,
    panelClassName,
    appendTo,
    itemTemplate,
  } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <Dropdown
          disabled={disabled}
          filter={shouldFilter}
          filterBy={filterBy || optionLabel}
          filterInputAutoFocus={true}
          id={field.name}
          value={field.value}
          options={options}
          optionLabel={optionLabel}
          editable={true}
          optionValue={optionValue}
          appendTo={appendTo}
          panelClassName={panelClassName}
          itemTemplate={itemTemplate}
          onChange={(e) => {
            if (onChange) {
              onChange(e);
            }
            field.onChange(e.value);
          }}
        />
      )}
    />
  );
};

export default EzControlledDropDown;
